import { graphql } from "@/gql";

export const generateRelocationImportTemplate = graphql(`
  mutation GenerateRelocationImportTemplate($supplierId: ID!) {
    generateImportTemplate(supplierId: $supplierId)
  }
`);
